import { FC } from 'react';

import type { ArticleOnce } from '@/entities/article';
import { BackButton } from '@/shared/ui';

import styles from './articleOnceHead.module.scss';

interface ArticleOnceHeadProps {
  value: ArticleOnce;
}

const ArticleOnceHead: FC<ArticleOnceHeadProps> = (props) => {
  const { value } = props;
  return (
    <section className={styles.section}>
      <BackButton className={styles.section__link} />
      <div className={styles.section__titleBlock}>
        <h1 className={styles.section__title}>{value?.name ?? ''}</h1>
      </div>
    </section>
  );
};

export default ArticleOnceHead;
